import { Dialog, DialogBody, DialogContent, DialogSurface, makeStyles } from '@fluentui/react-components'
import { OrganisationForm } from './OrganisationForm'
import { IModalState } from '../../interfaces/IModalState'
import { OrganisationWithUserAccountsDTO } from '../../api/schemas/schema'
import { IWelcomeEmailStatus } from '../../helpers/welcomeEmailHelper'
type ModalOrganisationFormProps = {
   modalState: IModalState<OrganisationWithUserAccountsDTO>
   setModalState: React.Dispatch<React.SetStateAction<IModalState<OrganisationWithUserAccountsDTO>>>
   onModalClose: () => void
   existingOrganisationNumbers: string[]
   welcomeEmailStatus: IWelcomeEmailStatus
   onWelcomeEmailSent: () => void
}
const useStyles = makeStyles({
   fullScreenDialog: {
      height: '100vh',
      margin: 0,
      padding: 0,
      gap: 0,
      maxWidth: 'none',
      maxHeight: 'none',
   },
})
export const ModalOrganisationForm = ({
   modalState,
   setModalState,
   onModalClose,
   existingOrganisationNumbers,
   welcomeEmailStatus,
   onWelcomeEmailSent,
}: ModalOrganisationFormProps) => {
   const classes = useStyles()
   return (
      <Dialog open={modalState.isOpen}>
         <DialogSurface className={classes.fullScreenDialog}>
            <DialogBody className={classes.fullScreenDialog}>
               <DialogContent>
                  <OrganisationForm
                     modalState={modalState}
                     setModalState={setModalState}
                     onModalClose={onModalClose}
                     existingOrganisationNumbers={existingOrganisationNumbers}
                     welcomeEmailStatus={welcomeEmailStatus}
                     onWelcomeEmailSent={onWelcomeEmailSent}
                  />
               </DialogContent>
            </DialogBody>
         </DialogSurface>
      </Dialog>
   )
}
